import axios from "axios";

const state = {
    Environment: {
        color: "indigo",
        name: "Default",
        scope: "Default",
        isMaster: false
    },
};

const getters = {
    getEnvironment: state => state.Environment
};

const actions = {
    async loadEnvironment({ commit }) {
        let environment = await axios.get(`/api/System/environment`);
        let syncOptions = await axios.get(`/api/System/sync`);

        commit('setEnvironment', { ...environment.data, "isMaster": syncOptions.data.isMaster || false });
    }
}

const mutations = {
    setEnvironment: (state, Environment) => (state.Environment = Environment)
};

export default { state, getters, actions, mutations };